module.exports = __webpack_public_path__ + "static/media/amazonwebservices-plain-wordmark.552eb116.svg";